import React from "react";
import { useField } from "formik";
import { Input } from "@design-system/Input/Input";
import styles from "../RuleForm.module.scss";

interface Props {
    index: number;
}

export const MemoActionForm: React.FC<Props> = ({ index }) => {
    const [field, , helpers] = useField<string>(`actions.${index}.value.memo`);

    return (
        <Input
            {...field}
            type="text"
            size="lg"
            onChange={(e) => helpers.setValue(e.target.value)}
            placeholder="Enter note"
            className={styles.memoInput}
        />
    );
};
